import { useSearchParams } from 'react-router-dom';
import InfoPanel from '../../reusable/InfoPanel/InfoPanel';
import { VIDEOS } from './data';
import { t } from '../../i18n/i18n';
import './Tutorials.scss';

/**
 * Tutorials — the live dashboard's Get Started videos (N77). No Figma frame
 * exists for it, so it is built from the Get started pages' own card
 * (`InfoPanel`): a player for the chosen video beside the list of all five,
 * the first one up by default, as on live.
 *
 * The chosen video lives in `?v=` so a link to one particular walkthrough —
 * from support, say — opens on it.
 */
export default function Tutorials() {
  const [params, setParams] = useSearchParams();
  const picked = VIDEOS.find((video) => video.id === params.get('v'));
  const active = picked ?? VIDEOS[0];

  // Autoplay only once the trader has chosen something: landing on the page
  // shouldn't start a 16-minute video by itself.
  const src = picked ? `${active.src}&autoplay=1` : active.src;

  const choose = (id) => setParams({ v: id }, { replace: true });

  return (
    <div className="tutorials">
      <header className="page-head">
        <h1 className="page-head__title">{t('Tutorials')}</h1>
        <p className="page-head__meta">
          {t('Short walkthroughs of the dashboard, MT5 and the market basics.')}
        </p>
      </header>

      <div className="tutorials__grid">
        <InfoPanel title={t('Get started with Alpha')} meta={active.length}>
          <div className="tut-player">
            {/* Keyed so a new pick replaces the frame instead of navigating
                the old one, which would add to the browser's history. */}
            <iframe
              key={active.id}
              className="tut-player__frame"
              src={src}
              title={t(active.title)}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
          <h2 className="tut-player__title">{t(active.title)}</h2>
        </InfoPanel>

        <InfoPanel title={t('Alpha get started videos')} meta={t('{{n}} videos', { n: VIDEOS.length })}>
          <ol className="tut-list">
            {VIDEOS.map((video, index) => {
              const current = video.id === active.id;
              return (
                <li key={video.id}>
                  <button
                    type="button"
                    className={`tut-item${current ? ' is-current' : ''}`}
                    aria-current={current || undefined}
                    onClick={() => choose(video.id)}
                  >
                    <span className="tut-item__thumb">
                      <img src={video.thumb} alt="" loading="lazy" />
                      <span className="tut-item__length">{video.length}</span>
                    </span>
                    <span className="tut-item__text">
                      <span className="tut-item__title">{t(video.title)}</span>
                      <span className="tut-item__meta">
                        {current ? t('Now playing') : t('Video {{n}}', { n: index + 1 })}
                      </span>
                    </span>
                  </button>
                </li>
              );
            })}
          </ol>
        </InfoPanel>
      </div>
    </div>
  );
}
